var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isChecked)?_c('div',{staticClass:"w-full min-h-screen bg-gray-300"},[_c('ev-header'),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }